export default __webpack_public_path__ + "static/media/download.bbef9d17.svg";